<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<template>

    <div>
        <Loader v-if="loading" />
        
        <div v-else>
            <div class="row mt-3 mt-md-45">
                <div class="col">
                    <p class="h4 font-weight-medium">Results <small v-if="results.results && results.results.length" class="font-italic text-sm">{{ `Showing ${showingComputed} of ${results.totalCount}` }}</small></p>
                </div>
            </div>

            <div class="row justify-content-between align-items-center mt-3">
                <div class="col-xl-4 col-lg-5">
                    <div class="row">
                        <div class="col-md-6">
                            <select class="custom-select" v-model="searchParams.chosenFacilityId" @change="filtersChanged()">
                                <option value="">All Facilities</option>
                                <option v-for="(facility, index) in allFacilities" :key="index" :value="facility.id">{{ facility.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-6 pl-md-0 mt-2 mt-md-0">
                            <select class="custom-select" v-model="searchParams.chosenPractitionerId" @change="filtersChanged()">
                                <option value="">All HCPs</option>
                                <option v-for="(practitioner, index) in allPractitioners" :key="index" :value="practitioner.id">{{ practitioner.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="col-xl-5 col-lg-7 mt-2 mt-md-0" id="status-filter">
                    <div class="d-flex flex-column flex-md-row align-items-center justify-content-end">
                        <div v-if="notificationCount > 0">
                            <div class="custom-tick dashboard-show-thresholds">
                                <div class="form-check">
                                    <input @change="getResults()" v-model="IsThresholdResults" class="form-check-input" type="checkbox">
                                    <label class="form-check-label">
                                        <span class="d-flex align-item-center">Show Organisation Thresholds? <img class="ml-1" v-b-tooltip.hover title="Thresholds can be set and viewed in Notifications" src="@/assets/images/icons/tooltip.svg" width="21" height="21" /></span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="ml-lg-4 d-flex align-items-center dashboard-status-container">
                            <label class="font-weight-medium d-none d-md-block text-sm mr-3 mb-0">Status</label>

                            <multiselect
                                v-model="selectedStatuses"
                                :options="statusOptions"
                                :multiple="true"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="All"
                                label="name"
                                track-by="name"
                                :preselect-first="true"
                                :searchable="false"
                                :show-labels="false"
                                :hideSelected="false"
                                @select="toggleSelected"
                                @remove="toggleUnselected"
                                @input="filtersChanged()">
                                    <template v-slot:tag="{option, remove}">
                                        <span v-if="option.name == 'All'" class="multi-select-all">All</span>
                                        <span v-if="option.name == 'New'" class="multi-select-badge badge-pill badge-new">New<span class="multi-select-remove" @click="remove(option)"> x</span></span>
                                        <span v-if="option.name == 'Issued'" class="multi-select-badge badge-pill badge-issued">Issued<span class="multi-select-remove" @click="remove(option)"> x</span></span>
                                        <span v-if="option.name == 'Returned'" class="multi-select-badge badge-pill badge-returned">Returned<span class="multi-select-remove" @click="remove(option)"> x</span></span>
                                        <span v-if="option.name == 'Complete'" class="multi-select-badge badge-pill badge-complete">Complete<span class="multi-select-remove" @click="remove(option)"> x</span></span>
                                        <span v-if="option.name == 'Cancelled'" class="multi-select-badge badge-pill badge-cancelled">Cancelled<span class="multi-select-remove" @click="remove(option)"> x</span></span>
                                        <span v-if="option.name == 'Reported'" class="multi-select-badge badge-pill badge-reported">Reported<span class="multi-select-remove" @click="remove(option)"> x</span></span>
                                        <span v-if="option.name == 'Failed'" class="multi-select-badge badge-pill badge-failed">Failed<span class="multi-select-remove" @click="remove(option)"> x</span></span>
                                        <span v-if="option.name == 'Error'" class="multi-select-badge badge-pill badge-error">Errored<span class="multi-select-remove" @click="remove(option)"> x</span></span>
                                    </template>
                                    <template v-slot:option="props">
                                        <div class="multi-select-option-custom">
                                            <input v-model="props.option.selected" type="checkbox" class="multi-select-checkbox" :disabled="props.option.name == 'All' && props.option.selected"/> 
                                            <span v-if="props.option.name == 'All'" class="multi-select-all">All</span>                              
                                            <span v-if="props.option.name == 'New'" class="multi-select-badge badge-pill badge-new">New</span>
                                            <span v-if="props.option.name == 'Issued'" class="multi-select-badge badge-pill badge-issued">Issued</span>
                                            <span v-if="props.option.name == 'Returned'" class="multi-select-badge badge-pill badge-returned">Returned</span>
                                            <span v-if="props.option.name == 'Complete'" class="multi-select-badge badge-pill badge-complete">Complete</span>
                                            <span v-if="props.option.name == 'Cancelled'" class="multi-select-badge badge-pill badge-cancelled">Cancelled</span>
                                            <span v-if="props.option.name == 'Reported'" class="multi-select-badge badge-pill badge-reported">Reported</span>
                                            <span v-if="props.option.name == 'Failed'" class="multi-select-badge badge-pill badge-failed">Failed</span>
                                            <span v-if="props.option.name == 'Error'" class="multi-select-badge badge-pill badge-error">Errored</span>
                                        </div>
                                    </template>
                                    <template v-slot:caret="{toggle}">
                                        <span class="multi-select-caret" @mousedown.prevent.stop="toggle">&nbsp;</span>
                                    </template>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!results.results.length">
                <div class="row mt-5">
                    <div class="col-md-6">
                        <div class="alert alert-info">
                            Your search query returned no results. Please try amending your search criteria
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="results.results && results.results.length" class="row mt-4">
                <div class="col">
                    <b-table 
                        ref="table"
                        id="table"
                        :sort-by.sync="sortBySync" 
                        :sort-desc.sync="sortDesc" 
                        @sort-changed="sortingChanged" 
                        :no-local-sorting="true"
                        :busy.sync="isBusy"
                        class="custom-table bg-white" 
                        responsive
                        no-sort-reset
                        :fields="filteredTestsFields" 
                        :items="results.results"
                    >
                        <template #cell(testNumber)="data">
                            <router-link :to="{name: 'ViewTest', params: {id : data.item.id}}" class="font-weight-bold underlined text-capitalize">{{ data.item.testNumber }}</router-link>
                            <div class="test-history-icons" v-if="data.item.replacedByTestId">
                                <img src="@/assets/images/icons/reorder-old-icon.svg" v-b-tooltip.hover title="This test has been reordered"/>
                            </div>
                            <div class="test-history-icons" v-else-if="data.item.replacesTestId">
                                <img src="@/assets/images/icons/reorder-new-icon.svg" v-b-tooltip.hover title="This test replaces a previous test"/>
                            </div>
                            <div class="test-history-icons" v-else-if="data.item.hasBeenPreviouslyReordered">
                                <img src="@/assets/images/icons/reorder-old-icon.svg" v-b-tooltip.hover title="Test has been previously reordered"/>
                            </div>
                        </template>

                        <template #cell(patientName)="data">
                            <router-link class="font-weight-bold underlined text-capitalize" :to="{name: 'ViewPatient', params: {id : data.item.patientId}}">{{ data.item.patientName }}</router-link>
                        </template>

                        <template v-if="isTrial" #cell(deviceNumber)="data">
                            <span v-if="data.item.deviceNumber">{{ data.item.deviceNumber }}</span>
                            <span v-else>N/A</span>
                        </template>

                        <template #cell(patientPostalCode)="data">
                            <span v-if="data.item.patientPostalCode" class="text-uppercase">{{ data.item.patientPostalCode }}</span>
                            <span v-else-if="data.item.shippingAddress && data.item.shippingAddress.city" class="text-uppercase">{{ data.item.shippingAddress.city }}</span>
                            <span v-else-if="data.item.shippingAddress && data.item.shippingAddress.country" class="text-uppercase">{{ data.item.shippingAddress.provinceName }}</span> 
                            <span v-else class="text-uppercase">N/A</span>
                        </template>

                        <template #cell(returnDate)="data">
                            <span v-if="data.item.latestResultsReviewed === false && (data.item.inReviewStatus == TestStatus.FAILED || data.item.inReviewStatus == TestStatus.ERROR)">N/A</span>
                            <span v-else>{{ formatDate(data.item.returnDate) }}</span>
                        </template>

                        <template #cell(status)="data">
                            <testStatuses :status="data.item.status" />
                        </template>

                        <template #cell(action)="data">
                            <router-link :to="{name: 'ViewTest', params: {id : data.item.id}}" class="btn btn-primary sm-shadow text-nowrap">View Test</router-link>
                        </template>
                    </b-table>

                    <div class="mt-4 d-flex flex-column flex-md-row align-items-center justify-content-end">
                        <div class="form-group d-flex align-items-center mb-4 mb-md-0">
                            <label class="flex-shrink-0 mr-2">Items per page</label>
                            <select class="custom-select" v-model="pageSize" @change="handleChangePageSize()">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                            </select>
                        </div>

                        <div>
                            <b-pagination
                                v-model="currentPage"
                                :current-page="currentPage"
                                :per-page="results.pageSize"
                                :total-rows="results.totalCount"
                                prev-text="< Previous"
                                next-text="Next >"
                                @change="pageChange"
                                aria-controls="table"
                                hide-goto-end-buttons
                                prev-class="prev-page"
                                next-class="next-page"
                                align="right"
                                class="mb-0"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {mapGetters, mapActions} from 'vuex'
import Loader from '../../../Common/components/Loader.vue'
import TestStatuses from '../../../Common/components/TestStatusesComponent.vue'
import TotalResultsMixin from '../../../Common/mixins/TotalResultsMixin'
import FormatterMixin from '../../../Common/mixins/FormatterMixin'
import Multiselect from 'vue-multiselect'
import TestStatus from '../../../Common/enums/TestStatus'
export default {
    name: 'TestResultsListComponent',

    components: {
        Loader,
        TestStatuses,
        Multiselect
    },

    mixins: [
        TotalResultsMixin,
        FormatterMixin
    ],

    watch: {
        async dashboardRefresh() {
            if(this) {
                this.clearSearchStore()

                this.sortBySync = "testNumber"
                this.sortColumn = "TEST_NUMBER"
                this.sortType = "DESCENDING"
                this.sortDesc = true
                this.currentPage = 1
                this.offset = 0

                await this.getNotificationCount()
                await this.getResults()
            }
        }
    },

    data() {
        return {
            loading: true,
            isBusy: false,
            notificationCount: 0,
            currentPage: 1,
            offset: 0,
            pageSize: process.env.VUE_APP_PAGINATION_PAGE_SIZE,
            sortColumn: "TEST_NUMBER",
            sortType: "DESCENDING",
            sortDesc: true,
            sortBySync: "testNumber",
            results: {
                results: []
            },
            statusOptions: [
                { name: 'All', status: 'ALL', selected: false},
                { name: 'New', status: 'NEW', selected: false},
                { name: 'Issued', status: 'ISSUED', selected: false},
                { name: 'Returned', status: 'RETURNED', selected: false},
                { name: 'Complete', status: 'COMPLETE', selected: false},
                { name: 'Cancelled', status: 'CANCELLED', selected: false},
                { name: 'Reported', status: 'REPORTED', selected: false},
                { name: 'Failed', status: 'FAILED', selected: false},
                { name: 'Error', status: 'ERROR', selected: false}
            ],
            selectedStatuses: [],
            IsThresholdResults: false,
            TestStatus
        }
    },

    async mounted() {
        if(!this.allPractitioners.length) {
            await this.getAllPractitioners()
        }

        if(!this.allFacilities.length) {
            await this.getAllFacilities()
        }
    
        await this.getNotificationCount()
        await this.getResults()
    },

    computed: {
        ...mapGetters({
            organisationId: 'UserStore/GetUserOrganisationId',
            isTrial: 'OrganisationStore/GetIsTrial',
            facilityId: 'UserStore/GetUserFacilityId',
            dashboardRefresh: 'SearchStore/GetDashboardRefresh',
            userId: 'UserStore/GetUserPractitionerId',
            patientIdentifierLabel: 'OrganisationStore/GetPatientIdentifierLabel',
            allFacilities: 'FacilityStore/GetAllFacilities',
            allPractitioners: 'PractitionerStore/GetAllPractitioners',
            searchParams: 'SearchStore/GetSearchParams',
        }),

        filteredTestsFields() {
            if(this.isTrial) {
                return [
                    {
                        key: 'testNumber',
                        label: 'Test Number',
                        sortable: true
                    },
                    {
                        key: 'patientName',
                        label: 'Patient name',
                        variant: 'text-wrap w-15',
                        sortable: true,
                    },
                    {
                        key: 'patientIdentifier',
                        label: this.patientIdentifierLabel,
                        sortable: true,
                    },
                    {
                        key: 'deviceNumber',
                        label: 'Device Number',
                        sortable: true,
                    },
                    {
                        key: 'patientDOB',
                        label: 'DOB',
                        sortable: true,
                        formatter: 'formatDate'
                    },
                    {
                        key: 'patientPostalCode',
                        label: 'Postcode',
                        sortable: true
                    },
                    {
                        key: 'issuedDate',
                        label: 'Issue Date',
                        sortable: true,
                        formatter: 'formatDate'
                    },
                    {
                        key: 'returnDate',
                        label: 'Return date',
                        sortable: true
                    },
                    {
                        key: 'dueDate',
                        label: 'Test date',
                        sortable: true,
                        formatter: 'formatDate'
                    },
                    {
                        key: 'gdEstimatedDeliveryDate',
                        label: 'EDD',
                        sortable: true,
                        formatter: 'formatDate'
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        sortable: true
                    },
                    {
                        key: 'practitionerName',
                        label: 'Assigned HCP',
                        variant: 'text-wrap w-15',
                        sortable: true,
                    },
                    {
                        key: 'facilityName',
                        label: 'Facility',
                        sortable: true,
                    },
                    {
                        key: 'action',
                        label: ''
                    }
                ]
            }
            
            return [
                {
                    key: 'testNumber',
                    label: 'Test Number',
                    sortable: true
                },
                {
                    key: 'patientName',
                    label: 'Patient name',
                    variant: 'text-wrap w-15',
                    sortable: true,
                },
                {
                    key: 'patientIdentifier',
                    label: this.patientIdentifierLabel,
                    sortable: true,
                },
                {
                    key: 'patientDOB',
                    label: 'DOB',
                    sortable: true,
                    formatter: 'formatDate'
                },
                {
                    key: 'patientPostalCode',
                    label: 'Location'
                },
                {
                    key: 'issuedDate',
                    label: 'Issue Date',
                    sortable: true,
                    formatter: 'formatDate'
                },
                {
                    key: 'returnDate',
                    label: 'Return date',
                    sortable: true,
                    formatter: 'formatDate'
                },
                {
                    key: 'dueDate',
                    label: 'Test date',
                    sortable: true,
                    formatter: 'formatDate'
                },
                {
                    key: 'gdEstimatedDeliveryDate',
                    label: 'EDD',
                    sortable: true,
                    formatter: 'formatDate'
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'practitionerName',
                    label: 'Assigned HCP',
                    variant: 'text-wrap w-15',
                    sortable: true,
                },
                {
                    key: 'facilityName',
                    label: 'Facility',
                    sortable: true,
                },
                {
                    key: 'dateUpdated',
                    label: 'Last Updated',
                    variant: 'text-wrap w-15',
                    formatter: 'formatDate',
                    sortable: true
                },
                {
                    key: 'action',
                    label: ''
                }
            ]
        }
    },

    methods: {
        ...mapActions({
            getAllFacilities: 'FacilityStore/GetAllFacilities',
            getAllPractitioners: 'PractitionerStore/GetAllPractitioners',
            clearSearchStore: 'SearchStore/ClearSearchStore',
            setDashboardRefresh: 'SearchStore/SetDashboardRefresh',
            setNotification: 'NotificationStore/SetNotification'
        }),

        async getNotificationCount() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_AXIOS_ORGANISATION_BASE_URL}/api/v1/notifications/${this.organisationId}/count`)
                this.notificationCount = response.data
            } catch {
                //
            }
        },

        async getResults() {
            this.isBusy = true

            let chosenStatusArray = []
            if(this.selectedStatuses) {

                let allStatus = this.selectedStatuses.find(x => x.status == 'ALL')
                if (allStatus) {
                    chosenStatusArray = []
                }
                else {
                    chosenStatusArray = this.selectedStatuses.map(s => s.status)
                } 
            }

            let searchModel = {
                organisationId: this.organisationId,
                facilityId: this.searchParams.chosenFacilityId ? this.searchParams.chosenFacilityId : "",
                practitionerId: this.searchParams.chosenPractitionerId ? this.searchParams.chosenPractitionerId : "",
                pageSize: this.pageSize,
                offset: this.offset,
                sortColumn: this.sortColumn,
                sortType: this.sortType,
                testStatus: chosenStatusArray,
                IsThresholdResults: this.IsThresholdResults
            }

            try {
                let response = await axios.post(`${process.env.VUE_APP_AXIOS_DIAGNOSTIC_BASE_URL}/api/v1/tests/search`, searchModel)
                this.results = response.data
            }
            catch(err) {
                this.setNotification({
                    type: 'error',
                    title: 'Error',
                    message: 'Something went wrong. Please try again'
                })
            }
            finally {
                this.loading = false
                this.isBusy = false
                this.setDashboardRefresh(false)
                this.$emit('loadingFinished')
            }
        },

        filtersChanged() {
            this.currentPage = 1
            this.offset = 0

            this.getResults()
        },

        sortingChanged(e) {
            switch(e.sortBy) {
                case 'patientName':
                    this.sortByValue = 'PATIENT_NAME'
                break;

                case 'testNumber':
                    this.sortByValue = 'TEST_NUMBER'
                break;

                case 'patientIdentifier':
                    this.sortByValue = 'PATIENT_IDENTIFIER'
                break;

                case 'deviceNumber':
                    this.sortByValue = 'DEVICE_NUMBER'
                break;

                case 'patientDOB':
                    this.sortByValue = 'PATIENT_DOB'
                break;

                case 'issuedDate':
                    this.sortByValue = 'ISSUED_DATE'
                break;

                case 'returnDate':
                    this.sortByValue = 'RETURN_DATE'
                break;

                case 'dueDate':
                    this.sortByValue = 'DUE_DATE'
                break;

                case 'gdEstimatedDeliveryDate':
                    this.sortByValue = 'EDD'
                break;

                case 'status':
                    this.sortByValue = 'STATUS'
                break;

                case 'practitionerName':
                    this.sortByValue = 'PRACTITIONER_NAME'
                break;

                case 'facilityName':
                    this.sortByValue = 'FACILITY_NAME'
                break;

                case 'dateUpdated':
                    this.sortByValue = 'LAST_UPDATED_DATE'
                break
            }
            
            this.sortColumn = this.sortByValue

            this.sortDesc = e.sortDesc

            if(this.sortDesc) {
                this.sortType = 'DESCENDING'
            } else {
                this.sortType = 'ASCENDING'
            }

            this.getResults()
        },

        pageChange(value) {         
            this.currentPage = value, 
            this.offset = (value - 1) * this.results.pageSize
            this.getResults()
        },

        refreshTable () {
            this.$refs.table.refresh()
        },

        toggleSelected(value) {
            let status = this.statusOptions.find(x => x.status == value.status)
            if (status) {
                status.selected = true;
            }

            if (value.status == 'ALL') {
                // Unselect all other options that aren't 'ALL'
                if (this.selectedStatuses) {
                    for (let i = this.selectedStatuses.length - 1; i >= 0 ; i--) {
                        if (this.selectedStatuses[i].status != "ALL") {                          
                            this.doUnselect(this.selectedStatuses[i])
                            this.selectedStatuses.splice(i,1)
                        }
                    }
                }
            }
            else {
                // Unselect the 'ALL' option
                if (this.selectedStatuses) {
                    for (let i = this.selectedStatuses.length - 1; i >= 0 ; i--) {
                        if (this.selectedStatuses[i].status == "ALL") {                         
                            this.doUnselect(this.selectedStatuses[i])
                            this.selectedStatuses.splice(i,1)
                            break
                        }
                    }
                }
            }
        },

        toggleUnselected(value) {

            if (this.selectedStatuses.length > 1 || (this.selectedStatuses.length == 1 && value.status != 'ALL')) {  
                this.doUnselect(value)
            }

            if (this.selectedStatuses.length == 1 && this.selectedStatuses[0].status == value.status) {
                // This means we're unselecting everything - we want to make it automatically select 'All'
                let allStatus = this.statusOptions.find(x => x.status == 'ALL')
                this.selectedStatuses.push(allStatus)
                this.doSelect(allStatus)
            }

        },

        doSelect(value) {
            let status = this.statusOptions.find(x => x.status == value.status)
            if (status) {
                status.selected = true;
            }
        },

        doUnselect(value) {
            let status = this.statusOptions.find(x => x.status == value.status)
            if (status) {
                status.selected = false;
            }
        },

        handleChangePageSize () {
            this.currentPage = 1
            this.offset = 0

            this.getResults()
        }
    }
}
</script>